export default __webpack_public_path__ + "static/media/NoiseLayer.d7ccf3ca.svg";